// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-select {
  position: relative;
}

.game-select__trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-2) var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  background: var(--color-parchment-100);
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  cursor: pointer;
  transition: border-color var(--transition-fast);
  text-align: left;
  box-sizing: border-box;
}

.game-select__trigger:hover {
  border-color: var(--color-fire-500);
}

.game-select__value {
  color: var(--color-text-primary);
}

.game-select__placeholder {
  color: var(--color-text-tertiary);
}

.game-select__arrow {
  font-size: 10px;
  color: var(--color-text-tertiary);
}

.game-select__clear {
  margin-top: var(--space-1);
  background: none;
  border: none;
  font-family: var(--font-body);
  font-size: var(--font-size-caption);
  color: var(--color-danger-500);
  cursor: pointer;
  padding: 0;
  transition: color var(--transition-fast);
}

.game-select__clear:hover {
  color: var(--color-danger-600);
}

.game-select__dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  z-index: var(--z-dropdown);
  overflow: hidden;
}

.game-select__toolbar {
  display: flex;
  align-items: stretch;
  border-bottom: 2px solid var(--color-wood-600);
}

.game-select__search {
  flex: 1;
  min-width: 0;
  padding: var(--space-2) var(--space-3);
  border: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  outline: none;
  box-sizing: border-box;
}

.game-select__search::placeholder {
  color: var(--color-text-tertiary);
}

.game-select__search:focus {
  background: var(--color-parchment-200);
}

.game-select__fav-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  border: none;
  border-left: 2px solid var(--color-wood-600);
  background: var(--color-parchment-100);
  cursor: pointer;
  font-size: 16px;
  transition: background var(--transition-fast);
}

.game-select__fav-toggle:hover {
  background: var(--color-parchment-200);
}

.game-select__fav-toggle--active {
  background: var(--color-fire-600);
}

.game-select__fav-toggle--active:hover {
  background: var(--color-fire-500);
}

.game-select__list {
  max-height: 200px;
  overflow-y: auto;
}

.game-select__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: none;
  background: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-text-primary);
  text-align: left;
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.game-select__option:hover {
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
}

.game-select__option--selected {
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  font-weight: var(--font-weight-semibold);
}

.game-select__option--favorite {
  background: rgba(184, 71, 14, 0.08);
}

.game-select__option--favorite:not(.game-select__option--selected):not(:hover) {
  border-left: 3px solid var(--color-fire-500);
  padding-left: calc(var(--space-3) - 3px);
}

.game-select__option-fav-icon {
  margin-right: var(--space-1);
  font-size: 12px;
}

.game-select__option-players {
  font-size: var(--font-size-body-sm);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}

.game-select__option:hover .game-select__option-players,
.game-select__option--selected .game-select__option-players {
  color: var(--color-parchment-200);
}

.game-select__empty {
  padding: var(--space-3);
  text-align: center;
  color: var(--color-text-tertiary);
  font-size: var(--font-size-body);
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,sCAAsC;EACtC,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;AAClC","sourcesContent":[".game-select {\n  position: relative;\n}\n\n.game-select__trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-2) var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  background: var(--color-parchment-100);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  transition: border-color var(--transition-fast);\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.game-select__trigger:hover {\n  border-color: var(--color-fire-500);\n}\n\n.game-select__value {\n  color: var(--color-text-primary);\n}\n\n.game-select__placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.game-select__arrow {\n  font-size: 10px;\n  color: var(--color-text-tertiary);\n}\n\n.game-select__clear {\n  margin-top: var(--space-1);\n  background: none;\n  border: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-caption);\n  color: var(--color-danger-500);\n  cursor: pointer;\n  padding: 0;\n  transition: color var(--transition-fast);\n}\n\n.game-select__clear:hover {\n  color: var(--color-danger-600);\n}\n\n.game-select__dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  z-index: var(--z-dropdown);\n  overflow: hidden;\n}\n\n.game-select__toolbar {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.game-select__search {\n  flex: 1;\n  min-width: 0;\n  padding: var(--space-2) var(--space-3);\n  border: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.game-select__search::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.game-select__search:focus {\n  background: var(--color-parchment-200);\n}\n\n.game-select__fav-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  border: none;\n  border-left: 2px solid var(--color-wood-600);\n  background: var(--color-parchment-100);\n  cursor: pointer;\n  font-size: 16px;\n  transition: background var(--transition-fast);\n}\n\n.game-select__fav-toggle:hover {\n  background: var(--color-parchment-200);\n}\n\n.game-select__fav-toggle--active {\n  background: var(--color-fire-600);\n}\n\n.game-select__fav-toggle--active:hover {\n  background: var(--color-fire-500);\n}\n\n.game-select__list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.game-select__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border: none;\n  background: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.game-select__option:hover {\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n}\n\n.game-select__option--selected {\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  font-weight: var(--font-weight-semibold);\n}\n\n.game-select__option--favorite {\n  background: rgba(184, 71, 14, 0.08);\n}\n\n.game-select__option--favorite:not(.game-select__option--selected):not(:hover) {\n  border-left: 3px solid var(--color-fire-500);\n  padding-left: calc(var(--space-3) - 3px);\n}\n\n.game-select__option-fav-icon {\n  margin-right: var(--space-1);\n  font-size: 12px;\n}\n\n.game-select__option-players {\n  font-size: var(--font-size-body-sm);\n  color: var(--color-text-tertiary);\n  flex-shrink: 0;\n}\n\n.game-select__option:hover .game-select__option-players,\n.game-select__option--selected .game-select__option-players {\n  color: var(--color-parchment-200);\n}\n\n.game-select__empty {\n  padding: var(--space-3);\n  text-align: center;\n  color: var(--color-text-tertiary);\n  font-size: var(--font-size-body);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
